module.exports = __webpack_public_path__ + "img/71.39eedf07.png";